import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./lib/i18n"; // Initialize i18n before app renders
import App from "./App";
import { registerAppServiceWorker } from "./lib/pwa";
import "@fontsource-variable/inter";
import "./global.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

registerAppServiceWorker();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
